// extracted by mini-css-extract-plugin
module.exports = {"select":"AppliedFiltersCategory_select__8Qm1O","cross":"AppliedFiltersCategory_cross__yUmUN"};